import Vue from 'vue'
import ElementUI from 'element-ui'
Vue.use(ElementUI, { size: 'small' })
